import { useContext, useEffect, useState } from 'react'
import Layout from '../../Component/layout/main-layout'
import { Link } from 'react-router-dom'
import { GetConstitutionLaws } from '../../api/Queries/get'
import pdf from '../../Images/icons/pdfdownload.svg'
import { useTranslation } from 'react-i18next';
import Loading from '../../Component/loader/loader';
import { Context } from '../../Store/context';
import LawsLayout from '../../Component/layout/laws-layout'
import LawCodesSearch from '../../Component/law-codes-search'
import layoutBgImg from '../../Images/layout/laws.png'
import { Get } from '../../api/services/api_helpers'
import GlobalLayout from '../../Component/layout/global-layout'

const ConstitutionLaws = () => {
    const [constitutionLaws, setConstitutionLaws] = useState([])
    const [search, setSearch] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const { t, i18n } = useTranslation();
    const { showError } = useContext(Context);
    const [recommendations, setRecommendations] = useState([]);
    const [recommendationLoading, setRecommendationLoading] = useState(false)
    const [showRecommendations, setShowRecommendations] = useState(true);

    const getLawName = (laws) => {
        const currentLang = i18n.language;
        if (currentLang === 'ru') {
            return laws.rus_name;
        } else if (currentLang === 'en') {
            return laws.eng_name;
        }
        return laws.tm_name;
    };

    const getPdfUrl = (laws) => {
        const currentLang = i18n.language;
        if (currentLang === 'ru') {
            return laws.rus_pdf;
        } else if (currentLang === 'en') {
            return laws.eng_pdf;
        }
        return laws.tm_pdf;
    };

    useEffect(() => {
        setIsLoading(true)
        const getConstitutionLaws = async () => {
            try {
                const data = await GetConstitutionLaws()
                setIsLoading(false)
                setConstitutionLaws(data)
            } catch (error) {
                showError(error.message);
                setIsLoading(false)
            }
        }
        getConstitutionLaws()
    }, [showError])


    const handleSearchClick = async (e) => {
        e.preventDefault();
        setShowRecommendations(false);
        if (!search) return;
        setIsLoading(true);
        try {
            const data = await Get(`constitutional-laws-search/?search=${search}`);
            setSearchResults(data);
        } catch (error) {
            showError(error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSearchClick(e);
        }
    };

    useEffect(() => {
        if (!search.trim()) {
            setRecommendations([]);
            setSearchResults([]);
            setShowRecommendations(true);
            return;
        }
        const fetchData = async () => {
            setRecommendationLoading(true);
            try {
                const data = await Get(`constitutional-laws-search/?search=${search}`);
                setRecommendations(data.slice(0, 10));
            } catch (error) {
                showError(error.message);
            } finally {
                setRecommendationLoading(false);
            }
        };

        fetchData();
    }, [search, showError]);

    return (
        <GlobalLayout
            title={`${t('tm_constitutionlaws')} - ${t('supreme_court')} ${t('turkmenistan')}`}
            keywords="Нормативные правовые акты, Kadalaşdyryjy hukuk namalar, 
            Ygtyyarnama, Ygtyýarnama, Kanun, Konstitusiýa, Konstitusiýa, Kodeks, Hukuk"
        >
            <div className='mb-20'>
                <Layout
                    title={t('laws_codes')}
                    page={t('tm_constitutionlaws')}
                    layoutBgImg={layoutBgImg}
                />
                <LawsLayout />

                <main className='media'>
                    <ul className='p-4 xl:p-8 bg-white dark:bg-dark-border'>

                        <LawCodesSearch
                            title={t('tm_constitutionlaws')}
                            search={search}
                            setSearch={setSearch}
                            handleSearchClick={handleSearchClick}
                            recommendations={recommendations}
                            recommendationLoading={recommendationLoading}
                            showRecommendations={showRecommendations}
                            handleKeyDown={handleKeyDown}
                        />

                        {isLoading ? <Loading /> :
                            <>
                                {searchResults.length > 0 && (
                                    <p className='text-lg md:text-xl font-bold flex gap-1 items-center
                                                  dark:text-dark-text'>
                                        {t('search_result')}
                                        <span className='flex gap-1'>
                                            (
                                            {searchResults.length}
                                            <p>{t('info')}</p>
                                            )
                                        </span>
                                    </p>
                                )}
                                {(searchResults.length ? searchResults : constitutionLaws)?.map((cons) => (
                                    <li key={cons.id}
                                        className='bg-gray dark:bg-dark-box dark:text-dark-text 
                                           flex justify-between items-center p-4 mt-4'>
                                        <Link to={`/constitutionlaws/${cons.id}`} className='w-[90%]'>
                                            <p>
                                                {getLawName(cons)}
                                            </p>
                                        </Link>
                                        <a
                                            href={getPdfUrl(cons)}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className='flex justify-end w-8 h-8'
                                        >
                                            <img src={pdf} alt="PDF" className='w-full h-full' />
                                        </a>
                                    </li>

                                ))}
                            </>
                        }
                        {isLoading ? '' : constitutionLaws.length === 0 && ''}
                    </ul>
                </main>
            </div>
        </GlobalLayout>
    )
}

export default ConstitutionLaws